export const IDLE_CONFIG = {
  // Inactivity limit before displaying the warning modal (15 minutes)
  IDLE_TIME_MS: 15 * 60 * 1000,
  // IDLE_TIME_MS: 120 * 1000, // 120 seconds for testing
  // Countdown duration inside the warning modal (2 minutes)
  COUNTDOWN_SECONDS: 120,
  // COUNTDOWN_SECONDS: 30, // 30 seconds for testing
};
